'use client'
import * as React from 'react'
import { Icon, type IconProps } from '../Icon'
const HouseIcon = React.forwardRef((props: IconProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      viewBox="0 0 24 24"
      ref={ref}
      {...props}
    >
      <path d="M20.5603 10.189L13.0603 2.68899C12.779 2.4079 12.3977 2.25 12 2.25C11.6024 2.25 11.221 2.4079 10.9397 2.68899L3.4397 10.189C3.29973 10.3279 3.18878 10.4933 3.1133 10.6755C3.03782 10.8577 2.99931 11.053 3.00001 11.2502V20.2502C3.00001 20.4492 3.07903 20.6399 3.21968 20.7806C3.36033 20.9212 3.5511 21.0002 3.75001 21.0002H9.75001C9.94892 21.0002 10.1397 20.9212 10.2803 20.7806C10.421 20.6399 10.5 20.4492 10.5 20.2502V15.0002H13.5V20.2502C13.5 20.4492 13.579 20.6399 13.7197 20.7806C13.8603 20.9212 14.0511 21.0002 14.25 21.0002H20.25C20.4489 21.0002 20.6397 20.9212 20.7803 20.7806C20.921 20.6399 21 20.4492 21 20.2502V11.2502C21.0007 11.053 20.9622 10.8577 20.8867 10.6755C20.8112 10.4933 20.7003 10.3279 20.5603 10.189ZM19.5 19.5002H15V14.2502C15 14.0513 14.921 13.8606 14.7803 13.7199C14.6397 13.5793 14.4489 13.5002 14.25 13.5002H9.75001C9.5511 13.5002 9.36033 13.5793 9.21968 13.7199C9.07903 13.8606 9.00001 14.0513 9.00001 14.2502V19.5002H4.50001V11.2502L12 3.75024L19.5 11.2502V19.5002Z" />
    </Icon>
  )
})
export { HouseIcon }
